import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiError } from '../../../types/apiError';
import { QUERY_KEYS } from '../../querykeys';
import { ConvertToScrumCheck, ConvertToScrumResult } from '../../../types/pmo/convertToScrum';
import { convertToScrum, getConvertToScrumCheck } from '../api/convertToScrum';

export const useConvertToScrumCheckQuery = (projectUuid?: string) =>
  useQuery<ConvertToScrumCheck, ApiError>({
    queryKey: QUERY_KEYS.PMO_CONVERT_TO_SCRUM_CHECK(projectUuid),
    queryFn: () => getConvertToScrumCheck(projectUuid as string),
    enabled: Boolean(projectUuid),
    // Counts move as people work, so each visit fetches them afresh.
    staleTime: 0,
  });

export const useConvertToScrumMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<ConvertToScrumResult, ApiError, string>({
    mutationFn: convertToScrum,
    onSuccess: (_result, projectUuid) =>
      // The board type picks the project's screens (List / Board → Backlog /
      // Active Sprint), and the project lists show it too.
      Promise.all([
        queryClient.invalidateQueries({ queryKey: ['project', projectUuid] }),
        queryClient.invalidateQueries({ queryKey: ['projects'] }),
        queryClient.invalidateQueries({ queryKey: ['projects-of-user'] }),
        queryClient.invalidateQueries({ queryKey: QUERY_KEYS.PMO_CONVERT_TO_SCRUM_CHECK(projectUuid) }),
      ]),
  });
};
